'use strict';

var React = require('react');

var SvgCollectionListIcon = function SvgCollectionListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 5.5c.414 0 .75.336.75.75v2.964c0 .862-.342 1.69-.952 2.299l-.018.017c-.293.293-.767.293-1.06 0-.293-.293-.293-.767 0-1.06l.017-.018c.329-.328.513-.773.513-1.238v-2.964c0-.414.336-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.767 4.098c.703-.703 1.657-1.098 2.652-1.098h2.081c1.519 0 2.75 1.231 2.75 2.75v2.289c0 .861-.342 1.688-.952 2.298l-4.206 4.206c-.976.976-2.56.976-3.536 0l-2.672-2.672c-1.074-1.075-1.074-2.816 0-3.89l3.883-3.883Zm2.652.402c-.597 0-1.17.237-1.591.659l-3.883 3.883c-.489.488-.489 1.28 0 1.768l2.672 2.672c.39.39 1.024.39 1.414 0l4.206-4.206c.329-.328.513-.773.513-1.237v-2.289c0-.69-.56-1.25-1.25-1.25h-2.081Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 6.5c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.75c0-.414.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75h-4.5c-.414 0-.75-.336-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.75c0-.414.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75h-4.5c-.414 0-.75-.336-.75-.75Z"
  }));
};
SvgCollectionListIcon.displayName = "CollectionListIcon";

exports.SvgCollectionListIcon = SvgCollectionListIcon;
